import {createUseStyles} from 'react-jss';
import getRGB from '../../v2/style-helper/getRGB';

const getBoxShadow = (props, size) => {
  let rgbValue = getRGB(props.theme.selectedFieldHighlight);
  
  if (props.isUsingArtemisStyles) {
    rgbValue = getRGB(props.theme.selectedFieldHighlightOverride || props.theme.selectedFieldHighlight);
  }
  
  return `0 0 0 ${size}px rgb(${rgbValue.r}, ${rgbValue.g}, ${rgbValue.b}, ${props.theme.selectedFieldSolidBoxShadow ? 1 : 0.5})`;
};

const getSelectedBoxShadow = props => props.isSelected && getBoxShadow(props, 3);

const boxShadowSizeOnFocus = props => (props.theme.selectedFieldSolidBoxShadow ? 5 : 6);

const getBorderColor = props => (props.isSelected && !props.alternativeBillingLayout ? props.theme.selectedFieldHighlight : '#8c8c8c');

const getArtemisStylesBorderColor = props => (props.isSelected
  ? (props.theme.selectedFieldHighlightOverride || props.theme.selectedFieldHighlight) : '#8c8c8c');

export default createUseStyles({
  container: props => ({
    borderStyle: props.styleAs === 'tab' || props.noBorder ? 'none' : 'solid',
    borderWidth: props.styleAs === 'tab' ? 0 : 1,
    borderColor: props.noBorder ? '#FFF' : getBorderColor(props),
    borderRadius: props.styleAs === 'tab' ? 0 : 4,
    boxShadow: !props.noBoxShadow && props.styleAs !== 'tab' && getSelectedBoxShadow(props),
    background: props.backgroundColour ? props.backgroundColour : 'transparent',
    padding: !props.noPadding && [16, 14],
    position: 'relative',
    flex: 1,
    display: props.wrapContent && 'flex',
    alignItems: props.wrapContent && 'center',
    width: props.fullWidth && '100%',
    color: props.isSelected && props.styleAs === 'tab' ? props.theme.button.tab.colour : '#333',
    textAlign: !!props.textAlign && props.textAlign,
    
    ...props.isUsingArtemisStyles && {
      borderColor: props.noBorder ? '#FFF' : getArtemisStylesBorderColor(props),
    },
    
    ...(props.styleAs === 'tab') && {
      marginBottom: props.isSelected && -1, // allow border to overlay main tab border
      borderBottom: props.isSelected ? `2px solid ${props.theme.button.tab.colour}` : 'none',
      
      '&:focus, &:hover': {
        background: `${props.theme.core.brand}33`, // 33 sets opacity to 20%
        color: props.theme.button.tab.colour,
        fill: props.theme.button.tab.colour,
      },
      '&:focus': {
        outline: `2px solid ${props.theme.button.tab.colour}`,
      },
    },
    
    ...(props.styleAs !== 'tab') && !props.noBoxShadow && {
      '&:focus-within': {
        boxShadow: getSelectedBoxShadow(props) ? `${getBoxShadow(props, boxShadowSizeOnFocus(props))}, ${getSelectedBoxShadow(props)}`
          : getBoxShadow(props, boxShadowSizeOnFocus(props)),
      },
    },
  }),
  tabIcon: {
    top: 2,
    position: 'relative',
    marginRight: 5,
    cursor: 'pointer',
    fill: props => (props.isSelected && props.styleAs === 'tab') && props.theme.button.tab.colour,
  },
  buttonIcon: {
    top: 5,
    position: props => (props.wrapContent ? 'initial' : 'relative'),
    marginRight: 5,
    cursor: 'pointer',
    fill: props => (props.isSelected && props.styleAs === 'tab') && props.theme.button.tab.colour,
  },
  checkIconTopRight: {
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(50%,-50%)',
    height: 24,
    width: 24,
  },
});
